import React from 'react'

function TickIcon({width, height, className}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 13.096 9.304">
            <path id="Path_938" data-name="Path 938" d="M33.347,43.237a.857.857,0,0,1-.608-.252l-3.792-3.792a.859.859,0,1,1,1.215-1.215l3.184,3.184,6.977-6.977A.859.859,0,1,1,41.539,35.4l-7.584,7.584A.857.857,0,0,1,33.347,43.237Z" transform="translate(-28.695 -33.934)" fill="#fff" />
        </svg>
    )
}

export default TickIcon